'use client';

import { cn } from '@lib/utils';

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  className?: string;
  /** 제목 요소의 id (aria-labelledby 연결용) */
  titleId?: string;
}

function CloseIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M1 1L13 13M1 13L13 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * 모달 헤더 컴포넌트
 * 제목과 닫기 버튼을 포함합니다.
 *
 * @example
 * <ModalHeader
 *   title="모달 제목"
 *   onClose={() => setIsOpen(false)}
 * />
 */
export function ModalHeader({
  title,
  onClose,
  className,
  titleId = 'modal-title',
}: ModalHeaderProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between px-5 py-5 md:px-10 md:pt-10',
        className,
      )}
    >
      <h3
        id={titleId}
        className="text-xl font-semibold tracking-[-0.44px] text-3b-text-primary md:text-[24px]"
      >
        {title}
      </h3>
      <button
        type="button"
        onClick={onClose}
        className="flex size-6 items-center justify-center text-3b-text-primary transition-colors hover:text-3b-text-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-3b-text-primary focus-visible:ring-offset-2"
        aria-label="Close modal"
      >
        <CloseIcon />
      </button>
    </div>
  );
}

export default ModalHeader;
